/* Flick · Cart drawer — abrir/cerrar + cantidad/eliminar por AJAX, render desde /cart.js */
(function () {
  var timers = {};
  var ROUTES = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var I = window.fkCartI18n || {};

  function el() { return document.querySelector('[data-fk-cd]'); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }
  function money(cents) { return '€' + (cents / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function sized(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  function setBadge(count) {
    document.querySelectorAll('.fk-bdg').forEach(function (b) { b.textContent = count; b.style.display = count < 1 ? 'none' : ''; });
  }

  function open() { var d = el(); if (!d) return; d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function close() { var d = el(); if (!d) return; d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

  function lineHTML(item) {
    var opts = '';
    if (item.variant_title && item.options_with_values) {
      opts = '<p class="fk-cd-opts">' + item.options_with_values.map(function (o) { return esc(o.value); }).join(' · ') + '</p>';
    }
    var was = item.original_line_price > item.final_line_price ? '<s>' + money(item.original_line_price) + '</s> ' : '';
    var img = item.image ? '<img src="' + sized(item.image, 200) + '" alt="' + esc(item.product_title) + '" width="100" height="100" loading="lazy">' : '<span class="fk-cd-ph"></span>';
    return '' +
      '<div class="fk-cd-row" data-fk-cd-item data-key="' + esc(item.key) + '">' +
        '<a href="' + esc(item.url) + '" class="fk-cd-img">' + img + '</a>' +
        '<div class="fk-cd-info">' +
          (item.vendor ? '<span class="fk-cd-v">' + esc(item.vendor) + '</span>' : '') +
          '<a href="' + esc(item.url) + '" class="fk-cd-name">' + esc(item.product_title) + '</a>' + opts +
          '<div class="fk-cd-ctrl">' +
            '<div class="fk-cd-stepper">' +
              '<button type="button" class="fk-cd-qbtn" data-fk-cd-step="-1" aria-label="' + esc(I.remove_one || 'Quitar uno') + '">&minus;</button>' +
              '<input type="number" class="fk-cd-qinput" value="' + item.quantity + '" min="0" inputmode="numeric" aria-label="' + esc(I.quantity || 'Cantidad') + '" data-fk-cd-qinput>' +
              '<button type="button" class="fk-cd-qbtn" data-fk-cd-step="1" aria-label="' + esc(I.add_one || 'Añadir uno') + '">+</button>' +
            '</div>' +
            '<span class="fk-cd-line">' + was + money(item.final_line_price) + '</span>' +
          '</div>' +
          '<button type="button" class="fk-cd-remove" data-fk-cd-remove>' + esc(I.remove || 'Eliminar') + '</button>' +
        '</div>' +
      '</div>';
  }

  function render(cart) {
    var d = el(); if (!d) return;
    var inner = d.querySelector('[data-fk-cd-inner]');
    var cnt = d.querySelector('[data-fk-cd-count]');
    if (cnt) cnt.textContent = '(' + cart.item_count + ')';
    setBadge(cart.item_count);
    if (!inner) return;
    if (cart.item_count === 0) {
      inner.innerHTML =
        '<div class="fk-cd-empty"><p class="fk-cd-empty-t">' + esc(I.empty_title || 'Tu carrito está vacío') + '</p>' +
        '<p class="fk-cd-empty-s">' + esc(I.empty_hint || 'Encuentra tu próximo palo, calzado o equipación.') + '</p>' +
        '<a href="' + ROUTES + 'collections/all" class="fk-cd-explore" data-fk-cd-close>' + esc(I.explore || 'Explorar la tienda') + '</a></div>';
      return;
    }
    var items = cart.items.map(lineHTML).join('');
    var checkout = ROUTES.replace(/\/$/, '') + '/cart';
    inner.innerHTML =
      '<div class="fk-cd-items">' + items + '</div>' +
      '<div class="fk-cd-foot">' +
        '<div class="fk-cd-sub"><span>' + esc(I.subtotal || 'Subtotal') + '</span><span>' + money(cart.total_price) + '</span></div>' +
        '<p class="fk-cd-taxnote">' + esc(I.taxnote || 'Impuestos incl. · Envío calculado en el pago') + '</p>' +
        '<a href="/checkout" class="fk-cd-checkout">' + esc(I.checkout || 'Finalizar compra') + '</a>' +
        '<a href="' + checkout + '" class="fk-cd-viewcart">' + esc(I.view || 'Ver carrito') + '</a>' +
      '</div>';
  }

  function getCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function refresh() { return getCart().then(render).catch(function () {}); }

  function change(key, qty, row) {
    if (row) row.setAttribute('data-fk-busy', '');
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) { render(cart); }).catch(function () { refresh(); });
  }

  function queue(row) {
    var key = row.dataset.key, input = row.querySelector('[data-fk-cd-qinput]');
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    clearTimeout(timers[key]);
    timers[key] = setTimeout(function () { change(key, qty, row); }, 380);
  }

  /* ---------- delegación ---------- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-fk-cart-open]');
    if (opener) { e.preventDefault(); open(); refresh(); return; }
    if (e.target.closest('[data-fk-cd-close]')) { e.preventDefault(); close(); return; }
    var step = e.target.closest('[data-fk-cd-step]');
    if (step) { var row = step.closest('[data-fk-cd-item]'); var i = row.querySelector('[data-fk-cd-qinput]'); i.value = Math.max(0, (parseInt(i.value, 10) || 0) + parseInt(step.dataset.fkCdStep, 10)); queue(row); return; }
    var rm = e.target.closest('[data-fk-cd-remove]');
    if (rm) { var r2 = rm.closest('[data-fk-cd-item]'); change(r2.dataset.key, 0, r2); return; }
  });
  document.addEventListener('change', function (e) { var i = e.target.closest('[data-fk-cd-qinput]'); if (i) queue(i.closest('[data-fk-cd-item]')); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
    if (e.key === 'Enter' && e.target.closest('[data-fk-cd-qinput]')) { e.preventDefault(); queue(e.target.closest('[data-fk-cd-item]')); }
  });

  /* ---------- API global ---------- */
  window.FlickCart = {
    open: open, close: close, refresh: refresh,
    add: function (id, quantity) {
      return fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id, quantity: quantity || 1 })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) { if (!res.ok) return res; open(); return refresh().then(function () { return res; }); });
    }
  };
})();
